import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={11} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M15.414 3.414 8 10.83.586 3.414 3.414.586 8 5.172 12.586.586z" clipRule="evenodd" />
  </svg>
);
export default SvgChevron;
